module.exports = __webpack_public_path__ + "img/scorecard-6.f9df32c0.jpg";